import { Outlet } from 'react-router-dom'

import useBreakpoint from 'src/shared/hooks/use-breakpoint'

import EnterpriseSidebarNav from './enterprise-sidebar-nav'

const EnterpriseSettingsLayout = () => {
  const { isMobile } = useBreakpoint()

  if (isMobile) {
    return (
      <div className="flex min-h-screen w-full bg-white">
        <Outlet />
      </div>
    )
  }

  return (
    <div className="size-full overflow-hidden bg-white">
      <div className="flex size-full min-h-0">
        <aside className="h-full w-[340px] shrink-0 overflow-y-auto border-r border-lightBorder px-6 py-8">
          <EnterpriseSidebarNav />
        </aside>
        <main className="min-w-0 flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default EnterpriseSettingsLayout
